module.exports = __webpack_public_path__ + "assets/img/pointer.2b1c48fb.png";